import checkPermission from "./checkPermission";

export const canListAllWallets = () =>
  checkPermission("list:wallet") || checkPermission("manage:wallet");

export const isOwnWalletOnlyUser = () =>
  checkPermission("header:wallet") && !canListAllWallets();

export const canShowWalletHeader = () => checkPermission("header:wallet");

export const canAccessOwnWallets = () =>
  checkPermission("header:wallet") || canListAllWallets();

export const canAccessAllWalletsList = () =>
  checkPermission("menu:wallets") && canListAllWallets();

export const canViewOwnContactWallets = () =>
  checkPermission("limited:wallet");

export const canOpenContactWallets = () =>
  canAccessAllWalletsList() || canViewOwnContactWallets();

export const canAccessWalletSection = () =>
  canAccessAllWalletsList() || checkPermission("header:wallet");

// Menu key is dedicated, but the data itself is the same rows list:wallet
// already governs per wallet — so no new data permission.
export const canAccessAllTransactionsList = () =>
  checkPermission("menu:wallet-transactions") && canListAllWallets();

export const canCreateWallet = () =>
  (checkPermission("menu:wallets") || checkPermission("header:wallet")) &&
  (checkPermission("create:wallet") || checkPermission("manage:wallet"));

export const canEmailWallet = () =>
  checkPermission("export:wallet") || checkPermission("manage:wallet");

// Deliberately not update:wallet — that one belongs to editing the wallet
// itself. Editing a transaction replays the ledger, so it has its own key.
export const canUpdateWalletTransaction = () =>
  (checkPermission("menu:wallets") || checkPermission("header:wallet")) &&
  (checkPermission("update_transaction:wallet") ||
    checkPermission("manage:wallet"));

export const getWalletHomePath = () =>
  isOwnWalletOnlyUser() ? "/my-wallets" : "/wallets";

export const getWalletTransactionsApiPath = (walletId) =>
  isOwnWalletOnlyUser()
    ? `/wallets/me/${walletId}/transactions`
    : `/wallets/${walletId}/transactions`;
